import { httpClient } from '@/infra/protocols/http';
import { IMusicUploadDTO } from '@/modules/musics/dto/music-upload.dto';
import { IMusicUpload } from '@/modules/musics/entities/music-upload.entity';
import { MusicUploadMapper } from '@/modules/musics/mappers/music-upload.mapper';

export async function associateMusic(
  params: AssociateMusicService.Params,
  data: AssociateMusicService.Payload,
): Promise<AssociateMusicService.Response> {
  const body = {
    nomeMusica: data.name,
  };

  const response = await httpClient.put<IMusicUploadDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/musicas/${data.id}`,
    body,
  );

  return MusicUploadMapper.toPresentation(response);
}

export namespace AssociateMusicService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export interface Payload {
    id: number;
    name: string;
  }

  export type Response = IMusicUpload;
}
